import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { http, apiError, formatPrice, imgSrc } from "@/lib/shop";
import { ProductForm } from "./ProductForm";

export const AdminProducts = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => http.get("/products").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (data) => {
    try {
      if (editing?._id) await http.put(`/products/${editing._id}`, data);
      else await http.post("/products", data);
      toast.success("Saved");
      setEditing(null);
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const remove = async (p) => {
    if (!window.confirm(`Delete ${p.name}?`)) return;
    try { await http.delete(`/products/${p._id}`); load(); } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-600">{items.length} listings. Leave price empty to show "Ask for price".</p>
        <button onClick={() => setEditing({})} className="inline-flex items-center gap-2 rounded-full bg-brand-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-brand-700" data-testid="admin-add-product-btn"><Plus className="h-4 w-4" /> Add product</button>
      </div>
      <div className="mt-4 grid gap-3">
        {items.map((p) => (
          <div key={p._id} className="flex items-center gap-4 bg-white rounded-xl border border-slate-200 p-3" data-testid={`admin-product-${p._id}`}>
            {p.image_url ? <img src={imgSrc(p.image_url)} alt="" className="h-16 w-16 rounded-lg object-cover bg-slate-100" /> : <div className="h-16 w-16 rounded-lg bg-slate-100" />}
            <div className="flex-1 min-w-0">
              <p className="font-bold truncate">{p.name}</p>
              <p className="text-xs text-slate-500">{p.category} · {p.condition}{p.storage ? ` · ${p.storage}` : ""}{p.in_stock ? "" : " · Sold out"}</p>
            </div>
            <p className="font-display font-bold w-24 text-right">{formatPrice(p.price) || <span className="text-xs text-amber-600">No price</span>}</p>
            <button onClick={() => setEditing(p)} className="p-2 rounded-full hover:bg-slate-100" aria-label="Edit" data-testid={`admin-edit-${p._id}`}><Pencil className="h-4 w-4" /></button>
            <button onClick={() => remove(p)} className="p-2 rounded-full hover:bg-red-50 text-red-600" aria-label="Delete" data-testid={`admin-delete-${p._id}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <ProductForm product={editing} onClose={() => setEditing(null)} onSave={save} />
    </div>
  );
};
